/*
 *
 * Activity constants
 *
 */

export const TOAST_ERROR = "app/TOAST_ERROR";
export const TOAST_SUCCESS = "app/TOAST_SUCCESS";
export const TOAST_WARNING = "app/TOAST_WARNING";

export const GET_ACTIVITY_DETAILS_REQUESTED = "activity/GET_ACTIVITY_DETAILS_REQUESTED";
export const GET_ACTIVITY_DETAILS_SUCCESS = "activity/GET_ACTIVITY_DETAILS_SUCCESS";
export const GET_ACTIVITY_DETAILS_FAILED = "activity/GET_ACTIVITY_DETAILS_FAILED";

export const ACTIVITY_LIKED_REQUESTED = "activity/ACTIVITY_LIKED_REQUESTED";
export const ACTIVITY_LIKED_SUCCESS = "activity/ACTIVITY_LIKED_SUCCESS";
export const ACTIVITY_LIKED_FAILED = "activity/ACTIVITY_LIKED_FAILED";

export const ACTIVITY_DERIVED_REQUESTED = "activity/ACTIVITY_DERIVED_REQUESTED";
export const ACTIVITY_DERIVED_SUCCESS = "activity/ACTIVITY_DERIVED_SUCCESS";
export const ACTIVITY_DERIVED_FAILED = "activity/ACTIVITY_DERIVED_FAILED";

export const ADD_ACTIVITY_COMMENT_REQUESTED = "activity/ADD_ACTIVITY_COMMENT_REQUESTED";
export const ADD_ACTIVITY_COMMENT_SUCCESS = "activity/ADD_ACTIVITY_COMMENT_SUCCESS";
export const ADD_ACTIVITY_COMMENT_FAILED = "activity/ADD_ACTIVITY_COMMENT_FAILED";

export const REPLY_TO_COMMENT_REQUESTED = "activity/REPLY_TO_COMMENT_REQUESTED";
export const REPLY_TO_COMMENT_SUCCESS = "activity/REPLY_TO_COMMENT_SUCCESS";
export const REPLY_TO_COMMENT_FAILED = "activity/REPLY_TO_COMMENT_FAILED";

export const EDIT_COMMENT_MODE = "activity/EDIT_COMMENT_MODE";

export const EDIT_COMMENT_REQUESTED = "activity/EDIT_COMMENT_REQUESTED";
export const EDIT_COMMENT_SUCCESS = "activity/EDIT_COMMENT_SUCCESS";
export const EDIT_COMMENT_FAILED = "activity/EDIT_COMMENT_FAILED";

export const DELETE_COMMENT_REQUESTED = "activity/DELETE_COMMENT_REQUESTED";
export const DELETE_COMMENT_SUCCESS = "activity/DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAILED = "activity/DELETE_COMMENT_FAILED";

export const LIKED_DISLIKED_COMMENT_REQUESTED = "activity/LIKED_DISLIKED_COMMENT_REQUESTED";
export const LIKED_DISLIKED_COMMENT_SUCCESS = "activity/LIKED_DISLIKED_COMMENT_SUCCESS";
export const LIKED_DISLIKED_COMMENT_FAILED = "activity/LIKED_DISLIKED_COMMENT_FAILED";

export const APPRECIATE_ACTIVITY_REQUESTED = "activity/APPRECIATE_ACTIVITY_REQUESTED";
export const APPRECIATE_ACTIVITY_SUCCESS = "activity/APPRECIATE_ACTIVITY_SUCCESS";
export const APPRECIATE_ACTIVITY_FAILED = "activity/APPRECIATE_ACTIVITY_FAILED";

export const SET_ACTIVITY_PUBLIC_REQUESTED = "activity/SET_ACTIVITY_PUBLIC_REQUESTED";
export const SET_ACTIVITY_PUBLIC_SUCCESS = "activity/SET_ACTIVITY_PUBLIC_SUCCESS";
export const SET_ACTIVITY_PUBLIC_FAILED = "activity/SET_ACTIVITY_PUBLIC_FAILED";

export const ADD_ACTIVITY_APPRECIATE_CANDIDATE_REQUESTED = "activity/ADD_ACTIVITY_APPRECIATE_CANDIDATE_REQUESTED";
export const ADD_ACTIVITY_APPRECIATE_CANDIDATE_SUCCESS = "activity/ADD_ACTIVITY_APPRECIATE_CANDIDATE_SUCCESS";
export const ADD_ACTIVITY_APPRECIATE_CANDIDATE_FAILED = "activity/ADD_ACTIVITY_APPRECIATE_CANDIDATE_FAILED";

export const REPORT_ACTIVITY_REQUESTED = "activity/REPORT_ACTIVITY_REQUESTED";
export const REPORT_ACTIVITY_SUCCESS = "activity/REPORT_ACTIVITY_SUCCESS";
export const REPORT_ACTIVITY_FAILED = "activity/REPORT_ACTIVITY_FAILED";

export const PUNISH_ACTIVITY_REQUESTED = "activity/PUNISH_ACTIVITY_REQUESTED";
export const PUNISH_ACTIVITY_SUCCESS = "activity/PUNISH_ACTIVITY_SUCCESS";
export const PUNISH_ACTIVITY_FAILED = "activity/PUNISH_ACTIVITY_FAILED";

export const ACCEPT_ACTIVITY_REQUESTED = "activity/ACCEPT_ACTIVITY_REQUESTED";
export const ACCEPT_ACTIVITY_SUCCESS = "activity/ACCEPT_ACTIVITY_SUCCESS";
export const ACCEPT_ACTIVITY_FAILED = "activity/ACCEPT_ACTIVITY_FAILED";

export const ACTIVITY_REGISTER_REQUESTED = "addActivity/ACTIVITY_REGISTER_REQUESTED";
export const ACTIVITY_REGISTER_SUCCESS = "addActivity/ACTIVITY_REGISTER_SUCCESS";
export const ACTIVITY_REGISTER_FAILED = "addActivity/ACTIVITY_REGISTER_FAILED";

export const UPDATE_CATEGORY_SUBJECTS_REQUEST = "activity/UPDATE_CATEGORY_SUBJECTS_REQUEST";
export const UPDATE_CATEGORY_SUBJECTS_SUCCESS = "activity/UPDATE_CATEGORY_SUBJECTS_SUCCESS";
export const UPDATE_CATEGORY_SUBJECTS_FAILED = "activity/UPDATE_CATEGORY_SUBJECTS_FAILED";

export const SET_ACTIVITY_DETAIL = "addActivity/SET_ACTIVITY_DETAIL";

export const ADD_SEEN = "addActivity/ADD_SEEN";
export const CLEAR_SEEN = "addActivity/CLEAR_SEEN";
